export default __webpack_public_path__ + "static/media/offer-vertical-chocolate.20257f8f.png";